import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ProviderTabs() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { label: t('common.dashboard'), path: '/provider/dashboard' },
    { label: t('providerBookings.title'), path: '/provider/bookings' },
    { label: t('providerAssets.title'), path: '/provider/assets' },
    { label: t('bottomNav.publish'), path: '/provider/post-asset' },
  ];

  return (
    <div className="border-b bg-white">
      <div className="container mx-auto max-w-7xl px-4 md:px-6 flex overflow-x-auto gap-2 py-3">
        {tabs.map(tab => (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className={`px-4 py-2 rounded-full text-sm whitespace-nowrap font-medium transition-all active:opacity-75 ${
              location.pathname === tab.path
                ? 'bg-black text-white'
                : 'border border-gray-300 text-gray-600 bg-white'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
